import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import BankAccountService from "services/lms/BankAccountService";
import ReceptionSuspendService from "services/lms/suspend/receptionSuspendService";
import dayjs from "dayjs";
import { notification } from "antd";


export const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  error: null,
  receptionSuspendList: [],
  bankAccounts: [],
  getCount: 0,
};

export const fetchgetReceptionSuspend = createAsyncThunk(
  "receptionSuspend/fetchgetReceptionSuspend",
  async (data) => {
    try {
      const response = await ReceptionSuspendService.getReceptionSuspend(data);
      return response.data;
    } catch (error) {
      console.error("Error fetching reception suspends:", error);
      throw error;
    }
  },
);

export const addReceptionSuspend = createAsyncThunk(
  "receptionSuspend/addReceptionSuspend",
  async (data, { dispatch }) => {
    try {
      const response = await ReceptionSuspendService.addReceptionSuspend(data);
      if (response.status === 200) {
        if (response.data.status === "Success") {
          notification.success({
            message: "Success",
            description: "Reception Suspend added successfully",
          });
          return response.data;
        }
      } else {
        notification.error({
          message: "Error",
          description: "Failed to add Reception Suspend",
        });
      }
    } catch (error) {
      console.error("Error adding reception suspend:", error);
      notification.error({
        message: "Error",
        description: "Failed to add Reception Suspend",
      });
      throw error;
    }
  },
);

export const fetchApproveSuspend = createAsyncThunk(
  "receptionSuspend/fetchApproveSuspend",
  async (data, { dispatch }) => {
    try {
      const response = await ReceptionSuspendService.fetchApproveSuspend(data);
      if (response.status === 200) {
        if (response.data.status === "Success") {
          notification.success({
            message: "Success",
            description: "Suspend approved successfully",
          });
          return response.data;
        } else {
          notification.error({
            message: response.data.status ?? "Error",
            description: response.data.message ?? "Failed to approve suspend",
          });
          return response.data;
        }
      } else {
        notification.error({
          message: "Error",
          description: "Failed to approve suspend",
        });
      }
    } catch (error) {
      console.error("Error approving suspend:", error);
      notification.error({
        message: "Error",
        description: error?.response?.data?.message ?? "Failed to approve suspend",
      });
      throw error;
    }
  },
);

export const fetchRejectSuspend = createAsyncThunk(
  "receptionSuspend/fetchRejectSuspend",
  async (data) => {
    try {
      const response = await ReceptionSuspendService.fetchRejectSuspend(data);
      if (response.status === 200) {
        if (response.data.status === "Success") {
          notification.success({
            message: "Success",
            description: "Suspend berhasil direject",
          });
          return response.data;
        } else {
          notification.error({
            message: response.data.status ?? "Error",
            description: response.data.message ?? "Gagal reject suspend",
          });
          return response.data;
        }
      } else {
        notification.error({
          message: "Error",
          description: "Gagal reject suspend",
        });
      }
    } catch (error) {
      console.error("Error rejecting suspend:", error);
      notification.error({
        message: "Error",
        description: error?.response?.data?.message ?? "Gagal reject suspend",
      });
      throw error;
    }
  },
);

const receptionSuspendSlice = createSlice({
  name: "receptionSuspend",
  initialState,
  reducers: {
    resetReceptionSuspendState: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.error = null;
      state.receptionSuspendList = [];
      state.getCount = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      // get reception suspend
      .addCase(fetchgetReceptionSuspend.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(fetchgetReceptionSuspend.fulfilled, (state, action) => {
        state.isLoading = false;
        state.receptionSuspendList = action.payload;
        state.getCount = action.payload?.count || 0;
      })
      .addCase(fetchgetReceptionSuspend.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error.message;
      })
      // end of get reception suspend
      // add reception suspend
      .addCase(addReceptionSuspend.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
      })
      .addCase(addReceptionSuspend.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = action.payload?.status === "Success";

        // Optionally, you can add the new reception suspend to the list
      })
      .addCase(addReceptionSuspend.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.error = action.error.message;
      })
      // end of add reception suspend
      // approve suspend
      .addCase(fetchApproveSuspend.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
      })
      .addCase(fetchApproveSuspend.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = action.payload?.status === "Success";
        // Optionally, you can update the reception suspend list to reflect the approved status
      })
      .addCase(fetchApproveSuspend.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.error = action.error.message;
      })
      // reject suspend
      .addCase(fetchRejectSuspend.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
      })
      .addCase(fetchRejectSuspend.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = action.payload?.status === "Success";
      })
      .addCase(fetchRejectSuspend.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.error = action.error.message;
      });
  },
});

export const { resetReceptionSuspendState } = receptionSuspendSlice.actions;
export default receptionSuspendSlice.reducer;
